/* global __DEVTOOLS__ */

require('es6-promise').polyfill();
require('universal-fetch');

export default class Fetch {

    static defaultHeaders() {
        return new Headers();
    };

    static defaultProps = {
        credentials: __DEVTOOLS__ ? 'include' : 'same-origin'
    };

    static get(url, customProps = Fetch.defaultProps, customHeaders = Fetch.defaultHeaders()) {
        return fetch(new Request(url), {
            ...Fetch.defaultProps, ...customProps, headers: customHeaders, method: 'GET'
        })
    }

    static post(url, data, customProps = Fetch.defaultProps, customHeaders = Fetch.defaultHeaders()) {
        return fetch(new Request(url), {
            ...Fetch.defaultProps, ...customProps, headers: customHeaders, body: data, method: 'POST'
        })
    }

    static put(url, data, customProps = Fetch.defaultProps, customHeaders = Fetch.defaultHeaders()) {
        return fetch(new Request(url), {
            ...Fetch.defaultProps, ...customProps, headers: customHeaders, body: data, method: 'PUT'
        })
    }

    static delete(url, data, customProps = Fetch.defaultProps, customHeaders = Fetch.defaultHeaders()) {
        return fetch(new Request(url), {
            ...Fetch.defaultProps, ...customProps, headers: customHeaders, body: data, method: 'DELETE'
        })
    }

    static patch(url, data, customProps = Fetch.defaultProps, customHeaders = Fetch.defaultHeaders()) {
        return fetch(new Request(url), {
            ...Fetch.defaultProps, ...customProps, headers: customHeaders, body: data, method: 'PATCH'
        })
    }
}
